module.exports = __webpack_public_path__ + "img/2.fe685034.png";